// GENERATED by casino/tools/gen-frontend.ts — do not edit by hand.
// Four-byte selectors and argument shapes for the Internet Casino contracts, derived from the
// compiled ABI so the site can never drift from the deployed bytecode without this file changing.

/* eslint-disable */

export const FN = {
  "House": {
    "BPS": {
      "sel": "0x249d39e9",
      "sig": "BPS()",
      "inputs": [],
      "outputs": [
        "uint16"
      ],
      "mut": "view"
    },
    "FEE_BPS": {
      "sel": "0xbf333f2c",
      "sig": "FEE_BPS()",
      "inputs": [],
      "outputs": [
        "uint16"
      ],
      "mut": "view"
    },
    "HOLDER_SHARE_CAP_BPS": {
      "sel": "0x5a8e75ae",
      "sig": "HOLDER_SHARE_CAP_BPS()",
      "inputs": [],
      "outputs": [
        "uint16"
      ],
      "mut": "view"
    },
    "MAX_EXPOSURE_CEIL": {
      "sel": "0xba5f8d3d",
      "sig": "MAX_EXPOSURE_CEIL()",
      "inputs": [],
      "outputs": [
        "uint16"
      ],
      "mut": "view"
    },
    "accrueFee": {
      "sel": "0xf3f89e74",
      "sig": "accrueFee(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "asset": {
      "sel": "0x38d52e0f",
      "sig": "asset()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "collect": {
      "sel": "0x6b8357ac",
      "sig": "collect(address,uint256)",
      "inputs": [
        "address",
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "dev": {
      "sel": "0x91cca3db",
      "sig": "dev()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "devAccrued": {
      "sel": "0xee244bb4",
      "sig": "devAccrued()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "distributor": {
      "sel": "0xbfe10928",
      "sig": "distributor()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "freeBankroll": {
      "sel": "0xfc958429",
      "sig": "freeBankroll()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "fund": {
      "sel": "0xca1d209d",
      "sig": "fund(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "holderAccrued": {
      "sel": "0x38fa0458",
      "sig": "holderAccrued()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "holderShareBps": {
      "sel": "0xf8c04f8d",
      "sig": "holderShareBps()",
      "inputs": [],
      "outputs": [
        "uint16"
      ],
      "mut": "view"
    },
    "isGame": {
      "sel": "0xc626c52e",
      "sig": "isGame(address)",
      "inputs": [
        "address"
      ],
      "outputs": [
        "bool"
      ],
      "mut": "view"
    },
    "maxExposureBps": {
      "sel": "0xe473f6ee",
      "sig": "maxExposureBps()",
      "inputs": [],
      "outputs": [
        "uint16"
      ],
      "mut": "view"
    },
    "maxPayout": {
      "sel": "0xe0176de8",
      "sig": "maxPayout()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "owner": {
      "sel": "0x8da5cb5b",
      "sig": "owner()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "paused": {
      "sel": "0x5c975abb",
      "sig": "paused()",
      "inputs": [],
      "outputs": [
        "bool"
      ],
      "mut": "view"
    },
    "payWin": {
      "sel": "0xa1df1c0f",
      "sig": "payWin(address,uint256,uint256)",
      "inputs": [
        "address",
        "uint256",
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "release": {
      "sel": "0x37bdc99b",
      "sig": "release(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "reserve": {
      "sel": "0x819b25ba",
      "sig": "reserve(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "reserved": {
      "sel": "0xfe60d12c",
      "sig": "reserved()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "setGame": {
      "sel": "0xb0836e2e",
      "sig": "setGame(address,bool)",
      "inputs": [
        "address",
        "bool"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "setHolderShareBps": {
      "sel": "0x0ee8b4df",
      "sig": "setHolderShareBps(uint16)",
      "inputs": [
        "uint16"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "setMaxExposureBps": {
      "sel": "0x16ecb144",
      "sig": "setMaxExposureBps(uint16)",
      "inputs": [
        "uint16"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "setOwner": {
      "sel": "0x13af4035",
      "sig": "setOwner(address)",
      "inputs": [
        "address"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "setPaused": {
      "sel": "0x16c38b3c",
      "sig": "setPaused(bool)",
      "inputs": [
        "bool"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "splitAllIn": {
      "sel": "0xcc7dbf40",
      "sig": "splitAllIn(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256",
        "uint256"
      ],
      "mut": "pure"
    },
    "sweepFees": {
      "sel": "0xd113b95c",
      "sig": "sweepFees()",
      "inputs": [],
      "outputs": [],
      "mut": "nonpayable"
    },
    "withdraw": {
      "sel": "0xf3fef3a3",
      "sig": "withdraw(address,uint256)",
      "inputs": [
        "address",
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    }
  },
  "DrandBeacon": {
    "CHAIN_HASH": {
      "sel": "0x9acbc4ca",
      "sig": "CHAIN_HASH()",
      "inputs": [],
      "outputs": [
        "bytes32"
      ],
      "mut": "view"
    },
    "GENESIS": {
      "sel": "0xb7dec1b7",
      "sig": "GENESIS()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "PERIOD": {
      "sel": "0xb4d1d795",
      "sig": "PERIOD()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "PUBLIC_KEY": {
      "sel": "0x030db445",
      "sig": "PUBLIC_KEY()",
      "inputs": [],
      "outputs": [
        "bytes"
      ],
      "mut": "view"
    },
    "isKnown": {
      "sel": "0x13cf2d4f",
      "sig": "isKnown(uint64)",
      "inputs": [
        "uint64"
      ],
      "outputs": [
        "bool"
      ],
      "mut": "view"
    },
    "randomnessOf": {
      "sel": "0x1edb4fbc",
      "sig": "randomnessOf(uint64)",
      "inputs": [
        "uint64"
      ],
      "outputs": [
        "bytes32"
      ],
      "mut": "view"
    },
    "require_": {
      "sel": "0xe34694cb",
      "sig": "require_(uint64,bytes)",
      "inputs": [
        "uint64",
        "bytes"
      ],
      "outputs": [
        "bytes32"
      ],
      "mut": "nonpayable"
    },
    "roundAt": {
      "sel": "0xefe99a24",
      "sig": "roundAt(uint64)",
      "inputs": [
        "uint64"
      ],
      "outputs": [
        "uint64"
      ],
      "mut": "pure"
    },
    "submit": {
      "sel": "0xec459679",
      "sig": "submit(uint64,bytes)",
      "inputs": [
        "uint64",
        "bytes"
      ],
      "outputs": [
        "bytes32"
      ],
      "mut": "nonpayable"
    },
    "timeOfRound": {
      "sel": "0xd167025a",
      "sig": "timeOfRound(uint64)",
      "inputs": [
        "uint64"
      ],
      "outputs": [
        "uint64"
      ],
      "mut": "pure"
    }
  },
  "BlueScreen": {
    "GRACE": {
      "sel": "0x137d29d9",
      "sig": "GRACE()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "MAX_LINE_BPS": {
      "sel": "0xc91d2db4",
      "sig": "MAX_LINE_BPS()",
      "inputs": [],
      "outputs": [
        "uint32"
      ],
      "mut": "view"
    },
    "MIN_DELAY": {
      "sel": "0x9f81aed7",
      "sig": "MIN_DELAY()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "MIN_LINE_BPS": {
      "sel": "0x2f623a45",
      "sig": "MIN_LINE_BPS()",
      "inputs": [],
      "outputs": [
        "uint32"
      ],
      "mut": "view"
    },
    "RTP_BPS": {
      "sel": "0xd7192ab0",
      "sig": "RTP_BPS()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "beacon": {
      "sel": "0x59659e90",
      "sig": "beacon()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "betAt": {
      "sel": "0xdb5a2d90",
      "sig": "betAt(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "(address,uint64,uint8,uint96,uint96,uint64,uint128,uint256)"
      ],
      "mut": "view"
    },
    "betCount": {
      "sel": "0xcf094497",
      "sig": "betCount()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "boot": {
      "sel": "0x0ccae03e",
      "sig": "boot(uint256,uint32)",
      "inputs": [
        "uint256",
        "uint32"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "nonpayable"
    },
    "chanceBps": {
      "sel": "0x4bb6c73e",
      "sig": "chanceBps(uint32)",
      "inputs": [
        "uint32"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "chanceWad": {
      "sel": "0x1950517a",
      "sig": "chanceWad(uint32)",
      "inputs": [
        "uint32"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "house": {
      "sel": "0xff9b3acf",
      "sig": "house()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "maxAllInFor": {
      "sel": "0xf8da41b9",
      "sig": "maxAllInFor(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "minAllIn": {
      "sel": "0x506d80c7",
      "sig": "minAllIn()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "refund": {
      "sel": "0x278ecde1",
      "sig": "refund(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "settle": {
      "sel": "0x39c2ebb9",
      "sig": "settle(uint256,bytes)",
      "inputs": [
        "uint256",
        "bytes"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "uptimeBps": {
      "sel": "0x398fc329",
      "sig": "uptimeBps(uint256,bytes32)",
      "inputs": [
        "uint256",
        "bytes32"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    }
  },
  "CoinFlip": {
    "GRACE": {
      "sel": "0x137d29d9",
      "sig": "GRACE()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "MAX_COINS": {
      "sel": "0x384302a9",
      "sig": "MAX_COINS()",
      "inputs": [],
      "outputs": [
        "uint8"
      ],
      "mut": "view"
    },
    "MIN_DELAY": {
      "sel": "0x9f81aed7",
      "sig": "MIN_DELAY()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "beacon": {
      "sel": "0x59659e90",
      "sig": "beacon()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "betAt": {
      "sel": "0xdb5a2d90",
      "sig": "betAt(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "(address,uint64,uint8,uint96,uint96,uint64,uint128,uint256)"
      ],
      "mut": "view"
    },
    "betCount": {
      "sel": "0xcf094497",
      "sig": "betCount()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "chanceBps": {
      "sel": "0xe1230fb3",
      "sig": "chanceBps(uint8)",
      "inputs": [
        "uint8"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "facesOf": {
      "sel": "0x9a1a01f6",
      "sig": "facesOf(uint256,uint8,bytes32)",
      "inputs": [
        "uint256",
        "uint8",
        "bytes32"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "flip": {
      "sel": "0x6db54844",
      "sig": "flip(uint256,uint8,uint8)",
      "inputs": [
        "uint256",
        "uint8",
        "uint8"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "nonpayable"
    },
    "house": {
      "sel": "0xff9b3acf",
      "sig": "house()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "maxAllInFor": {
      "sel": "0xf8da41b9",
      "sig": "maxAllInFor(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "minAllIn": {
      "sel": "0x506d80c7",
      "sig": "minAllIn()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "payoutMultBps": {
      "sel": "0x769bd54f",
      "sig": "payoutMultBps(uint8)",
      "inputs": [
        "uint8"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "refund": {
      "sel": "0x278ecde1",
      "sig": "refund(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "settle": {
      "sel": "0x39c2ebb9",
      "sig": "settle(uint256,bytes)",
      "inputs": [
        "uint256",
        "bytes"
      ],
      "outputs": [],
      "mut": "nonpayable"
    }
  },
  "DialUp": {
    "GRACE": {
      "sel": "0x137d29d9",
      "sig": "GRACE()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "MAX_PACKETS": {
      "sel": "0x9ad8cd3a",
      "sig": "MAX_PACKETS()",
      "inputs": [],
      "outputs": [
        "uint8"
      ],
      "mut": "view"
    },
    "MIN_DELAY": {
      "sel": "0x9f81aed7",
      "sig": "MIN_DELAY()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "PORTS": {
      "sel": "0x18eda0d6",
      "sig": "PORTS()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "ROWS": {
      "sel": "0x0cc23225",
      "sig": "ROWS()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "beacon": {
      "sel": "0x59659e90",
      "sig": "beacon()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "betAt": {
      "sel": "0xdb5a2d90",
      "sig": "betAt(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "(address,uint64,uint8,uint96,uint96,uint64,uint128,uint256)"
      ],
      "mut": "view"
    },
    "betCount": {
      "sel": "0xcf094497",
      "sig": "betCount()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "dial": {
      "sel": "0x8ed76b44",
      "sig": "dial(uint256,uint8)",
      "inputs": [
        "uint256",
        "uint8"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "nonpayable"
    },
    "house": {
      "sel": "0xff9b3acf",
      "sig": "house()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "ladderRtpBps": {
      "sel": "0x6d6cac6a",
      "sig": "ladderRtpBps()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "maxAllInFor": {
      "sel": "0xf8da41b9",
      "sig": "maxAllInFor(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "minAllIn": {
      "sel": "0x506d80c7",
      "sig": "minAllIn()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "multBps": {
      "sel": "0x6b4cfb4f",
      "sig": "multBps(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "portOf": {
      "sel": "0x1f181e37",
      "sig": "portOf(uint256,uint256,bytes32)",
      "inputs": [
        "uint256",
        "uint256",
        "bytes32"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "refund": {
      "sel": "0x278ecde1",
      "sig": "refund(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "settle": {
      "sel": "0x39c2ebb9",
      "sig": "settle(uint256,bytes)",
      "inputs": [
        "uint256",
        "bytes"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "weightOf": {
      "sel": "0x0767d178",
      "sig": "weightOf(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    }
  },
  "Mines": {
    "GRACE": {
      "sel": "0x137d29d9",
      "sig": "GRACE()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "MAX_MULT_BPS": {
      "sel": "0xa52800c9",
      "sig": "MAX_MULT_BPS()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "MIN_DELAY": {
      "sel": "0x9f81aed7",
      "sig": "MIN_DELAY()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "RTP_BPS": {
      "sel": "0xd7192ab0",
      "sig": "RTP_BPS()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "TILES": {
      "sel": "0xb083324e",
      "sig": "TILES()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "beacon": {
      "sel": "0x59659e90",
      "sig": "beacon()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "betAt": {
      "sel": "0xdb5a2d90",
      "sig": "betAt(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "(address,uint64,uint8,uint96,uint96,uint64,uint128,uint256)"
      ],
      "mut": "view"
    },
    "betCount": {
      "sel": "0xcf094497",
      "sig": "betCount()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "chanceBps": {
      "sel": "0x2e1bf110",
      "sig": "chanceBps(uint8,uint256)",
      "inputs": [
        "uint8",
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "chanceWad": {
      "sel": "0xbee23ba8",
      "sig": "chanceWad(uint8,uint256)",
      "inputs": [
        "uint8",
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "house": {
      "sel": "0xff9b3acf",
      "sig": "house()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "maxAllInFor": {
      "sel": "0xf8da41b9",
      "sig": "maxAllInFor(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "minAllIn": {
      "sel": "0x506d80c7",
      "sig": "minAllIn()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "mineMaskOf": {
      "sel": "0x302a57d5",
      "sig": "mineMaskOf(uint256,uint8,bytes32)",
      "inputs": [
        "uint256",
        "uint8",
        "bytes32"
      ],
      "outputs": [
        "uint32"
      ],
      "mut": "pure"
    },
    "payoutMultBps": {
      "sel": "0x5728469c",
      "sig": "payoutMultBps(uint8,uint256)",
      "inputs": [
        "uint8",
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "popcount": {
      "sel": "0xbaff7e90",
      "sig": "popcount(uint32)",
      "inputs": [
        "uint32"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "refund": {
      "sel": "0x278ecde1",
      "sig": "refund(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "settle": {
      "sel": "0x39c2ebb9",
      "sig": "settle(uint256,bytes)",
      "inputs": [
        "uint256",
        "bytes"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "sweep": {
      "sel": "0x1f0ef8d7",
      "sig": "sweep(uint256,uint8,uint32)",
      "inputs": [
        "uint256",
        "uint8",
        "uint32"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "nonpayable"
    }
  },
  "Roulette": {
    "ALL_POCKETS": {
      "sel": "0x472b56a5",
      "sig": "ALL_POCKETS()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "GRACE": {
      "sel": "0x137d29d9",
      "sig": "GRACE()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "MIN_DELAY": {
      "sel": "0x9f81aed7",
      "sig": "MIN_DELAY()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "PAY_NUMERATOR_BPS": {
      "sel": "0x58c1621e",
      "sig": "PAY_NUMERATOR_BPS()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "POCKETS": {
      "sel": "0x6bbf93f2",
      "sig": "POCKETS()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "beacon": {
      "sel": "0x59659e90",
      "sig": "beacon()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "betAt": {
      "sel": "0xdb5a2d90",
      "sig": "betAt(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "(address,uint64,uint8,uint96,uint96,uint64,uint128,uint256)"
      ],
      "mut": "view"
    },
    "betCount": {
      "sel": "0xcf094497",
      "sig": "betCount()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "boardRtpBps": {
      "sel": "0xb609f609",
      "sig": "boardRtpBps()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "chanceWad": {
      "sel": "0x347cd97a",
      "sig": "chanceWad(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "house": {
      "sel": "0xff9b3acf",
      "sig": "house()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "maxAllInFor": {
      "sel": "0xf8da41b9",
      "sig": "maxAllInFor(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "minAllIn": {
      "sel": "0x506d80c7",
      "sig": "minAllIn()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "payoutMultBps": {
      "sel": "0x2ef8b1a4",
      "sig": "payoutMultBps(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "pocketOf": {
      "sel": "0x01d7b460",
      "sig": "pocketOf(uint256,bytes32)",
      "inputs": [
        "uint256",
        "bytes32"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "popcount": {
      "sel": "0x1204bab4",
      "sig": "popcount(uint64)",
      "inputs": [
        "uint64"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "refund": {
      "sel": "0x278ecde1",
      "sig": "refund(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "settle": {
      "sel": "0x39c2ebb9",
      "sig": "settle(uint256,bytes)",
      "inputs": [
        "uint256",
        "bytes"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "spin": {
      "sel": "0x808486cd",
      "sig": "spin(uint256,uint64)",
      "inputs": [
        "uint256",
        "uint64"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "nonpayable"
    }
  },
  "Dice": {
    "GRACE": {
      "sel": "0x137d29d9",
      "sig": "GRACE()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "MAX_TARGET": {
      "sel": "0xf7ba2c0d",
      "sig": "MAX_TARGET()",
      "inputs": [],
      "outputs": [
        "uint16"
      ],
      "mut": "view"
    },
    "MIN_DELAY": {
      "sel": "0x9f81aed7",
      "sig": "MIN_DELAY()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "MIN_TARGET": {
      "sel": "0xb640a95d",
      "sig": "MIN_TARGET()",
      "inputs": [],
      "outputs": [
        "uint16"
      ],
      "mut": "view"
    },
    "ROLL_SPACE": {
      "sel": "0x49458a50",
      "sig": "ROLL_SPACE()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "RTP_BPS": {
      "sel": "0xd7192ab0",
      "sig": "RTP_BPS()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "beacon": {
      "sel": "0x59659e90",
      "sig": "beacon()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "betAt": {
      "sel": "0xdb5a2d90",
      "sig": "betAt(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "(address,uint64,uint8,uint96,uint96,uint64,uint128,uint256)"
      ],
      "mut": "view"
    },
    "betCount": {
      "sel": "0xcf094497",
      "sig": "betCount()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "chanceWad": {
      "sel": "0xc94ae745",
      "sig": "chanceWad(uint16)",
      "inputs": [
        "uint16"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "house": {
      "sel": "0xff9b3acf",
      "sig": "house()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "maxAllInFor": {
      "sel": "0xf8da41b9",
      "sig": "maxAllInFor(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "minAllIn": {
      "sel": "0x506d80c7",
      "sig": "minAllIn()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "payoutMultBps": {
      "sel": "0x52994461",
      "sig": "payoutMultBps(uint16)",
      "inputs": [
        "uint16"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "refund": {
      "sel": "0x278ecde1",
      "sig": "refund(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "roll": {
      "sel": "0xaf6f8e7d",
      "sig": "roll(uint256,uint16)",
      "inputs": [
        "uint256",
        "uint16"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "nonpayable"
    },
    "rollOf": {
      "sel": "0x6587d8ac",
      "sig": "rollOf(uint256,bytes32)",
      "inputs": [
        "uint256",
        "bytes32"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "settle": {
      "sel": "0x39c2ebb9",
      "sig": "settle(uint256,bytes)",
      "inputs": [
        "uint256",
        "bytes"
      ],
      "outputs": [],
      "mut": "nonpayable"
    }
  },
  "Wheel": {
    "GRACE": {
      "sel": "0x137d29d9",
      "sig": "GRACE()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "MAX_MULT_BPS": {
      "sel": "0xa52800c9",
      "sig": "MAX_MULT_BPS()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "MAX_SPINS": {
      "sel": "0x864638a5",
      "sig": "MAX_SPINS()",
      "inputs": [],
      "outputs": [
        "uint8"
      ],
      "mut": "view"
    },
    "MIN_DELAY": {
      "sel": "0x9f81aed7",
      "sig": "MIN_DELAY()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "SEGMENTS": {
      "sel": "0x4a028a8e",
      "sig": "SEGMENTS()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "beacon": {
      "sel": "0x59659e90",
      "sig": "beacon()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "betAt": {
      "sel": "0xdb5a2d90",
      "sig": "betAt(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "(address,uint64,uint8,uint96,uint96,uint64,uint128,uint256)"
      ],
      "mut": "view"
    },
    "betCount": {
      "sel": "0xcf094497",
      "sig": "betCount()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "house": {
      "sel": "0xff9b3acf",
      "sig": "house()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "maxAllInFor": {
      "sel": "0xf8da41b9",
      "sig": "maxAllInFor(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "minAllIn": {
      "sel": "0x506d80c7",
      "sig": "minAllIn()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "multBps": {
      "sel": "0x6b4cfb4f",
      "sig": "multBps(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "refund": {
      "sel": "0x278ecde1",
      "sig": "refund(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "segmentCounts": {
      "sel": "0x137c0e1a",
      "sig": "segmentCounts()",
      "inputs": [],
      "outputs": [
        "uint256[5]"
      ],
      "mut": "pure"
    },
    "segmentOf": {
      "sel": "0xc4b97c78",
      "sig": "segmentOf(uint256,uint256,bytes32)",
      "inputs": [
        "uint256",
        "uint256",
        "bytes32"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "settle": {
      "sel": "0x39c2ebb9",
      "sig": "settle(uint256,bytes)",
      "inputs": [
        "uint256",
        "bytes"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "spin": {
      "sel": "0x2cf3181e",
      "sig": "spin(uint256,uint8)",
      "inputs": [
        "uint256",
        "uint8"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "nonpayable"
    },
    "wheelRtpBps": {
      "sel": "0xf801b644",
      "sig": "wheelRtpBps()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    }
  },
  "Slots": {
    "BIN": {
      "sel": "0x5232a558",
      "sig": "BIN()",
      "inputs": [],
      "outputs": [
        "uint8"
      ],
      "mut": "view"
    },
    "CLIPPY": {
      "sel": "0x9210f917",
      "sig": "CLIPPY()",
      "inputs": [],
      "outputs": [
        "uint8"
      ],
      "mut": "view"
    },
    "DISK": {
      "sel": "0x1786b5ba",
      "sig": "DISK()",
      "inputs": [],
      "outputs": [
        "uint8"
      ],
      "mut": "view"
    },
    "FOLDER": {
      "sel": "0xe1fd5f7e",
      "sig": "FOLDER()",
      "inputs": [],
      "outputs": [
        "uint8"
      ],
      "mut": "view"
    },
    "GLOBE": {
      "sel": "0x7010f852",
      "sig": "GLOBE()",
      "inputs": [],
      "outputs": [
        "uint8"
      ],
      "mut": "view"
    },
    "GRACE": {
      "sel": "0x137d29d9",
      "sig": "GRACE()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "MAX_MULT_BPS": {
      "sel": "0xa52800c9",
      "sig": "MAX_MULT_BPS()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "MINE": {
      "sel": "0x5061029d",
      "sig": "MINE()",
      "inputs": [],
      "outputs": [
        "uint8"
      ],
      "mut": "view"
    },
    "MIN_DELAY": {
      "sel": "0x9f81aed7",
      "sig": "MIN_DELAY()",
      "inputs": [],
      "outputs": [
        "uint64"
      ],
      "mut": "view"
    },
    "REELS": {
      "sel": "0x62f21208",
      "sig": "REELS()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "RTP_BPS": {
      "sel": "0xd7192ab0",
      "sig": "RTP_BPS()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "STOPS": {
      "sel": "0x98f90c74",
      "sig": "STOPS()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "beacon": {
      "sel": "0x59659e90",
      "sig": "beacon()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "betAt": {
      "sel": "0xdb5a2d90",
      "sig": "betAt(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "(address,uint64,uint8,uint96,uint96,uint64,uint128,uint256)"
      ],
      "mut": "view"
    },
    "betCount": {
      "sel": "0xcf094497",
      "sig": "betCount()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "house": {
      "sel": "0xff9b3acf",
      "sig": "house()",
      "inputs": [],
      "outputs": [
        "address"
      ],
      "mut": "view"
    },
    "machineRtpBps": {
      "sel": "0x25944744",
      "sig": "machineRtpBps()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "maxAllInFor": {
      "sel": "0xf8da41b9",
      "sig": "maxAllInFor(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "minAllIn": {
      "sel": "0x506d80c7",
      "sig": "minAllIn()",
      "inputs": [],
      "outputs": [
        "uint256"
      ],
      "mut": "view"
    },
    "payBps": {
      "sel": "0x5712b313",
      "sig": "payBps(uint8,uint8,uint8)",
      "inputs": [
        "uint8",
        "uint8",
        "uint8"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "refund": {
      "sel": "0x278ecde1",
      "sig": "refund(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "settle": {
      "sel": "0x39c2ebb9",
      "sig": "settle(uint256,bytes)",
      "inputs": [
        "uint256",
        "bytes"
      ],
      "outputs": [],
      "mut": "nonpayable"
    },
    "spin": {
      "sel": "0xa5b6ea8f",
      "sig": "spin(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "nonpayable"
    },
    "stopOf": {
      "sel": "0xd70f4d9d",
      "sig": "stopOf(uint256,uint256,bytes32)",
      "inputs": [
        "uint256",
        "uint256",
        "bytes32"
      ],
      "outputs": [
        "uint256"
      ],
      "mut": "pure"
    },
    "symbolAt": {
      "sel": "0xd3dc454e",
      "sig": "symbolAt(uint256)",
      "inputs": [
        "uint256"
      ],
      "outputs": [
        "uint8"
      ],
      "mut": "pure"
    }
  }
};

// ERC-20, the three calls the cabinets need.
export const ERC20 = {
  "balanceOf": {
    "sel": "0x70a08231",
    "inputs": [
      "address"
    ],
    "outputs": [
      "uint256"
    ]
  },
  "allowance": {
    "sel": "0xdd62ed3e",
    "inputs": [
      "address",
      "address"
    ],
    "outputs": [
      "uint256"
    ]
  },
  "approve": {
    "sel": "0x095ea7b3",
    "inputs": [
      "address",
      "uint256"
    ],
    "outputs": [
      "bool"
    ]
  },
  "decimals": {
    "sel": "0x313ce567",
    "inputs": [],
    "outputs": [
      "uint8"
    ]
  },
  "symbol": {
    "sel": "0x95d89b41",
    "inputs": [],
    "outputs": [
      "string"
    ]
  }
};

// Event topics the site filters on, so a cabinet can find its own bets without an indexer.
export const TOPIC = {
  "ExposureSet": "0xf38a0584e76f9091f259b33671e79023ef9bd1a696c2372e6cc8b1d76a9b600a",
  "FeeAccrued": "0x3001032df6bcdb6b5b70f3e8d9f8913991b3a538d3186e38137447ebc9973fab",
  "FeesSwept": "0xaf739f46ca7a23c9f259838ec2c5249acf4e1cf9fe68a46f77c3dfa452eda605",
  "Funded": "0x5af8184bef8e4b45eb9f6ed7734d04da38ced226495548f46e0c8ff8d7d9a524",
  "GameSet": "0xe540a8b437eafdce2a0c84b49b3a920e1dfac8ac432291ab5f1dcf1a86b4b24f",
  "HolderShareSet": "0x8dd96c3b75a5fbca0ae4e410932ed7dbd88c61cb2d824a8ea43bc2f7881c11c8",
  "OwnerSet": "0x50146d0e3c60aa1d17a70635b05494f864e86144a2201275021014fbf08bafe2",
  "Paid": "0x9def4e2802183d68ce90a6a226a2962b59298616c27165f12c4fbc5c84cdd778",
  "PausedSet": "0x40db37ff5c0bdc2c427fbb2078c8f24afea940abac0e3c23bb4ea3bf2da2b212",
  "Released": "0xb21fb52d5749b80f3182f8c6992236b5e5576681880914484d7f4c9b062e619e",
  "Reserved": "0x904dcdc411e931497b95b06ddf8f8184815dd3bedc3c7c7cd4aed3ccd30783d8",
  "RoundStored": "0x76aa7b66d7461c70a587c700af123fda4ff8537735054e8daf55cd907a7337f6",
  "Placed": "0x9ade5001a2a934ee12f0e7ca88658420ddbf0fa87ab4d39d30056a55a72bf5f6",
  "Refunded": "0x7ca5472b7ea78c2c0141c5a12ee6d170cf4ce8ed06be3d22c8252ddfc7a6a2c4",
  "Settled": "0x5aceddbfb9e6ba8f777b07043d3b9c13d986a735bb73ff372f1772081fad0fec"
};
